import { useContext } from 'react';
import SettingsContext from '../contexts/SettingsContext.js';

export function useSettings() {
  const context = useContext(SettingsContext);
  if (!context) throw new Error('useSettings must be used within SettingsProvider');
  return context;
}

export default useSettings;
